import store from 'store';

export const updateCurrentWidgetProperty = ({
  item,
  pageEditorModelDataState,
  dispatch,
  setPageEditorModelData,
  pageEditorModelDataActivePage,
  pageEditorModelDataPageList,
  activePageFindIndex,
  pageId,
}) => {
  
  const state = store.getState();
  pageEditorModelDataPageList = state?.pageEditorModelData?.pageEditorModelData || [];
  activePageFindIndex = activePageFindIndex >=0 ? activePageFindIndex : pageEditorModelDataPageList?.findIndex(
    value => value.pageId === pageId,
  );
  pageEditorModelDataActivePage = pageEditorModelDataActivePage ? pageEditorModelDataActivePage : pageEditorModelDataPageList?.[activePageFindIndex];
  pageEditorModelDataState = pageEditorModelDataState ? pageEditorModelDataState : pageEditorModelDataPageList?.[activePageFindIndex]?.pageWidgetPropsList;

  pageEditorModelDataState &&
    pageEditorModelDataState.map(e => {
      if (e.id === item.id) {
        const listofProps = [...pageEditorModelDataState];
        // console.log("240822 listofProps checkk: ", listofProps);
        //console.log("e checkkk: ", e);
        const index = listofProps.indexOf(e);

        listofProps.splice(index, 1, item);

        //console.log("listofProps checkk afterSlice: ", listofProps);

        const activepageDtlsNew = { ...pageEditorModelDataActivePage };
        activepageDtlsNew['pageWidgetPropsList'] = listofProps;
        // console.log("activepageDtlsNew checkk afterSlice: ", activepageDtlsNew);
        const applnDtlsObj = [...pageEditorModelDataPageList];
        applnDtlsObj.splice(activePageFindIndex, 1, activepageDtlsNew);

        dispatch(
          setPageEditorModelData({
            pageEditorModelData: applnDtlsObj,
          }),
        );
      }
    });
};
const compProps = {
  button: ['primaryColor', 'corner', 'shadow', 'border', 'appFont', 'widgetSize'],
  checkbox: ['appFont'],
  radiobutton: ['appFont'],
  dropdown: ['appFont', 'icons', 'widgetSize', 'inputBaseColor'],
  textinput: ['appFont', 'corner', 'border', 'shadow', 'inputBaseColor', 'widgetSize'],
  fileinput: ['appFont', 'corner', 'border', 'shadow', 'inputBaseColor', 'widgetSize'],
  numberinput: ['appFont', 'corner', 'border', 'shadow', 'inputBaseColor', 'widgetSize'],
  textarea: ['appFont', 'corner', 'border', 'widgetSize'],
  dateandtime: ['appFont', 'corner', 'shadow'],
  formcontainer: ['corner', 'border'],
  text: ['appFont'],
  container: ['backgroundColor'],
  div: ['backgroundColor'],
  row: ['backgroundColor'],
};
export const getThemeProperties = ({ widgetCode, selectedThemeProps, widgetKeyList }) => {
  const themeProp = () => {
    const widgetThemeKeys = compProps[widgetCode] ? compProps[widgetCode] : [];

    const widgetThemeProps = {};
    let keyList = [];
    if (widgetKeyList?.length === 0) {
      keyList = widgetThemeKeys;
    } else {
      widgetKeyList?.map(ele => {
        widgetThemeKeys?.map(e => {
          if (e === ele || e === 'inputBaseColor' || e === 'appFont') {
            keyList.push(e);
          }
        });
      });
      //keyList = widgetKeyList;
    }
    keyList?.map(e => {
      widgetThemeProps[e] = selectedThemeProps[e];
    });

    return widgetThemeProps;
  };
  const properitesObj = themeProp();

  return properitesObj;
};
export const getDefaultProperties = ({ widgetCode }) => {
  const widgetThemeKeys = compProps[widgetCode] ? compProps[widgetCode] : [];

  const widgetThemeProps = {};

  widgetThemeKeys?.map(e => {
    widgetThemeProps[e] = false;
  });

  return widgetThemeProps;
};
export const getWidgetUniqueCodeForPage = ({ widgetCode }) => {
  const widgets = {
    Button: 'btn',
    CheckBox: 'chkbx',
    RadioButton: 'rdo',
    Toggle: 'tgl',
    DropDown: 'snglslct',
    TextInput: 'txinp',
    DateAndTime: 'dtpkr',
    FormContainer: 'form',
    Text: 'txt',
    TextArea: 'txtarea',
    NumberInput: 'ninp',
    FileInput: 'finpt',
    Container: 'cntnr',
    Grid: 'grid',
    ImageCard: 'imgcrd',
    Section: 'sctn',
    Link: 'lnk',
    MenuButton: 'mbtn',
    Tabs: 'tabs',
    Chip: 'chip',
    Alert: 'alrt',
    Shapes: 'shap',
    Line: 'line',
    Progress: 'pgres',
    Spacer: 'spacer',
    Card: 'card',
    BoundingBox: 'bndbox',
    Div: 'blok',
    ModuleChatbot: 'chbot',
    SlideBlock: 'sblok',
    FloatingBox: 'fblok',
    Popup: 'pup',
    Row: 'row',
    Image: 'img',
    Video: 'vdo',
    Audio: 'ado',
    Icon: 'icn',
    IconButton: 'ibtn',
    Col: 'col',
    MultiLineInputText: 'mlinp',
    Iframe: 'ifm',
    Password: 'pwd',
    Url: 'url',
    Email: 'eml',
    InputNumber: 'inptnmbr',
    MultiSelect: 'msel',
    TranslateLanguage: 'trnsl',
    SingleSelect: 'ssel',
    Repeator: 'rptr',
    CurrencyInput: 'crinp',
    TimePicker: 'tpkr',
    DatePicker: 'dpkr',
    Carousel: 'caro',
    GoogleMap: 'gmap',
    Ratings: 'rtng',
    Popover: 'povr',
    CustomisedAccordion: 'acrdn',
    Conversation: 'conversation',
    PlaceAutoComplete: 'plcautocomplt',
    PhoneNumberInput: 'phonenumberinput',
    InputPhone: 'phonenumberinput',
    Table: 'table',
    StaticRepeater: 'stRptr',
    StaticRepeaterContent: 'stRptrCntnt',
    StaticRepeaterJSON: 'stRptr',
  };
  return widgets[widgetCode];
};

export function findAndUpdateValueByKey(obj = {}, property, value) {
  function traverse(traverseObj) {
    for (var i in traverseObj) {
      if (i === property) {
        traverseObj[property] = value;

        break;
      } else if (!!traverseObj[i] && typeof traverseObj[i] == 'object') traverse(traverseObj[i]);
    }
  }

  traverse(obj);

  return obj;
}

export function getFontStyleandFontWeight({ fntStyl }) {
  const getFontStyle = style => {
    const characters = style?.match(/[a-z]+/gi)?.join('');

    const numbers = style?.match(/\d+/g)?.join('');
    const fontStyleandWeight = {
      fontStyle: characters,
      fontWeight: numbers,
    };
    return fontStyleandWeight;
  };

  const isalpha = /^[a-zA-Z]+$/.test(fntStyl);
  const isNumeric = /^[0-9]+$/.test(fntStyl);
  //console.log('isalnum true', isalpha, fntStyl);
  const styleObj = getFontStyle(fntStyl) || {};

  const fontWeight = isalpha ? 400 : isNumeric ? fntStyl : styleObj?.fontWeight;

  const fontStyle = isalpha
    ? fntStyl?.toLowerCase() === 'regular'
      ? 'normal'
      : fntStyl?.toLowerCase()
    : isNumeric
    ? 'normal'
    : styleObj?.fontStyle;

  return { fontWeight: fontWeight, fontStyle: fontStyle };
}
